export { GridChartsModule } from "./gridChartsModule";
import { time } from "ag-charts-community";
export var agCharts = {
  time: time
};